import React, { useState } from "react";
import "../index.css";
import buttonBackground from "../assets/button_background_blue.webp";

interface ValidationError {
  title: string;
  message: string;
}

// Type definitions
interface SportbookData {
  id: string;
  name: string;
}

interface SportbooksMetadata {
  [key: string]: SportbookData;
}

interface WatcherFormSportbooksProps {
  sportbooksMetadata: SportbooksMetadata;
  formState: number;
  setFormState: (state: number) => void;
  books: string[];
  setBooks: (books: string[]) => void;
}

const WatcherFormSportbooks: React.FC<WatcherFormSportbooksProps> = ({
  sportbooksMetadata,
  formState,
  setFormState,
  books,
  setBooks,
}) => {
  const [innerBooks, setInnerBooks] = useState<string[]>(books);
  const [validationError, setValidationError] =
    useState<ValidationError | null>(null);
  const sportbookKeys = Object.keys(sportbooksMetadata);
  const sortedKeys = sportbookKeys.sort();

  const handlePrevious = (): void => {
    setFormState(formState - 1);
  };

  const handleNext = (): void => {
    if (innerBooks.length === 0) {
      setValidationError({
        title: "Sportsbook Selection Required",
        message: "Please select at least one sportsbook to continue.",
      });
      return;
    }
    setBooks(innerBooks);
    setFormState(formState + 1);
  };

  const handleChange = (value: string): void => {
    const updatedItems = innerBooks.includes(value)
      ? innerBooks.filter((item) => item !== value)
      : [...innerBooks, value];

    setInnerBooks(updatedItems);
  };

  return (
    <div
      style={{
        marginTop: 10,
        padding: "0 10px",
        maxWidth: 800,
        margin: "0 auto",
      }}
    >
      <div className="row center_me">
        <div
          className=" border_radius"
          style={{
            // backgroundColor: "#2a2a2a",
            // borderRadius: 8,
            marginTop: 10,
            paddingLeft: 15,
            paddingRight: 15,
          }}
        >
          <h2
            className="font_family_base "
            style={{
              fontSize: 16,
              fontWeight: "bold",
              marginBottom: 10,
              textAlign: "center",
              marginTop: 10,
              // color: "#fff",
            }}
          >
            Need another sportsbook supported? Please use the "Contact Us" page
            and we will be happy to add it.
          </h2>
        </div>
      </div>
      <h2
        className="font_family_base text_green"
        style={{
          fontSize: 20,
          fontWeight: "bold",
          marginBottom: 20,
          textAlign: "center",
          marginTop: 10,
          width: "100%",
        }}
      >
        Select Sportsbooks to Follow
      </h2>
      <div className="center_me">
        <div
          className="border_radius center_me"
          style={{
            marginBottom: 10,
            maxWidth: 500,
            width: "100%",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            {sortedKeys.map((item) => {
              const id = sportbooksMetadata[item].id;
              const checked = innerBooks.includes(id);
              return (
                <div
                  key={item}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    // paddingTop: 5,
                    // paddingBottom: 5,
                  }}
                >
                  <label
                    className="border_radius"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      // padding: "10px 14px",
                      cursor: "pointer",
                      // border: checked ? "1px solid #4ade80" : "1px solid transparent",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => handleChange(id)}
                      style={{
                        width: 18,
                        height: 18,
                        accentColor: "#007AFF",
                        cursor: "pointer",
                        margin: 4,
                      }}
                    />
                    <span
                      className="font_family_base"
                      style={{ color: "#fff", fontSize: 16 }}
                    >
                      {sportbooksMetadata[item].name}
                    </span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: 16,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        <button
          className="my-form-button button-base button-3d font_family_base"
          style={{
            marginTop: "5px",
            marginBottom: "5px",
            backgroundImage: `url(${buttonBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "white",
            fontWeight: 700,
          }}
          onClick={handlePrevious}
        >
          ← Previous
        </button>
        <button
          className="my-form-button button-base button-3d font_family_base"
          style={{
            marginTop: "5px",
            marginBottom: "5px",
            backgroundImage: `url(${buttonBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "white",
            fontWeight: 700,
          }}
          onClick={handleNext}
        >
          Next →
        </button>
      </div>
      {/* Validation Error Modal */}
      {validationError && (
        <div
          onClick={() => setValidationError(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="background_2 border_radius"
            style={{
              padding: 30,
              maxWidth: 400,
              width: "90%",
              textAlign: "center",
              border: "1px solid #333",
            }}
          >
            <h3
              className="font_family_base"
              style={{
                color: "#fff",
                marginBottom: 15,
                fontSize: 20,
              }}
            >
              {validationError.title}
            </h3>
            <p
              className="font_family_base"
              style={{
                color: "#ccc",
                marginBottom: 25,
                fontSize: 16,
                lineHeight: 1.5,
              }}
            >
              {validationError.message}
            </p>
            <button
              onClick={() => setValidationError(null)}
              className="my-form-button-wide button-base button-3d font_family_base"
              style={{
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
                padding: "12px 24px",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WatcherFormSportbooks;
